<template>
  <div>
      <user-info
          :userInformationUrl="userInformationUrl"
          :revokeUserUrl="revokeUserUrl"
          :restoreUserUrl="restoreUserUrl"
          :updateUserPermissionsUrl="updateUserPermissionsUrl"
          globalUser>
      </user-info>
  </div>
</template>
<script>
  import Vue from 'vue'
  import Loader from '@/components/misc/Loader'
  import UserInfo from '@/components/misc/user-info/UserInfo'

  export default {
    name: 'user-information',
    components: {
      Loader,
      UserInfo
    },
    data () {
      return {
        userInformationUrl: '',
        updateUserPermissionsUrl: '',
        revokeUserUrl: '',
        restoreUserUrl: '',
        userId: this.$route.params.userId
      }
    },
    created: function () {
      this.userInformationUrl = Vue.$apiConfig.userInformationGet
      this.updateUserPermissionsUrl = Vue.$apiConfig.updateUserPermissionsPost
      this.revokeUserUrl = Vue.$apiConfig.userDisablePost
      this.restoreUserUrl = Vue.$apiConfig.userEnablePost
    }
  }
</script>



// WEBPACK FOOTER //
// UserInformation.vue?22f02ae5